import Formsy from 'formsy-react';
export default Formsy;